import { render } from "./ExternalServiceConsentNotice.vue?vue&type=template&id=d71cbd02"
import script from "./ExternalServiceConsentNotice.vue?vue&type=script&lang=js"
export * from "./ExternalServiceConsentNotice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__